import { render, staticRenderFns } from "./DealsAndSpecialsView.vue?vue&type=template&id=40931c8c&scoped=true&"
import script from "./DealsAndSpecialsView.vue?vue&type=script&lang=js&"
export * from "./DealsAndSpecialsView.vue?vue&type=script&lang=js&"
import style0 from "./DealsAndSpecialsView.vue?vue&type=style&index=0&id=40931c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40931c8c",
  null
  
)

export default component.exports